// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_2WXsx","showIcon":"P4xCE"};